import { Box, Typography, Avatar } from '@mui/material';

function AboutPage() {

  const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;

  return (



    <Box>



      <Typography sx={{ typography: { xs: 'subtitle2', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '2px', textUnderlineOffset: '5px' }} >About Us</Typography>

      <Box>


        <Box sx={{ display: 'flex', justifyContent: 'center' }} mt={4}>
          <Avatar alt='App Logo' src={process.env.REACT_APP_LOGO_URL} sx={{ width: 'auto', height: 'auto' }} />
        </Box>

        <Box mt={4}>
          <Typography>



            Interpreters and Translators, Inc. is a family-owned business located in Glastonbury, Connecticut. Founded in 1985, iTi is a full-service language services provider, with clients ranging from small businesses to international
            corporations. iTi has been certified as a minority-owned business by the NMSDC.
          </Typography>


        </Box>
      </Box>
    </Box>

  )
}

export default AboutPage